import { styled } from '@mui/material/styles';
import { 
  Menu, 
  MenuItem, 
  Divider, 
  IconButton, 
  Avatar as MuiAvatar, 
  Typography 
} from '@mui/material';

export const ProfileButton = styled(IconButton)(({ theme }) => ({
  padding: 0,
  marginLeft: theme.spacing(2),
  border: '2px solid rgba(255, 255, 255, 0.2)',
  '&:hover': {
    border: '2px solid rgba(255, 255, 255, 0.4)',
  }
}));

export const Avatar = styled(MuiAvatar)(({ theme }) => ({
  width: 36,
  height: 36,
  fontWeight: 600,
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
}));

export const StyledMenu = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    minWidth: 200,
    backgroundColor: '#1e2a38',
    color: 'white',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
    marginTop: theme.spacing(1),
  }
}));

export const MenuHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(2),
}));

export const UserName = styled(Typography)({
  fontWeight: 600,
  marginTop: 8,
});

export const UserEmail = styled(Typography)({
  fontSize: '0.75rem',
  color: 'rgba(255, 255, 255, 0.7)',
});

export const UserRole = styled(Typography)({
  fontSize: '0.75rem',
  color: 'rgba(255, 255, 255, 0.7)',
  marginTop: 4,
  backgroundColor: 'rgba(33, 150, 243, 0.2)',
  padding: '2px 8px',
  borderRadius: 12,
  display: 'inline-block',
});

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  padding: '10px 16px',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
  }
}));

export const MenuItemText = styled(Typography)({
  marginLeft: 8,
});

export const StyledDivider = styled(Divider)({
  backgroundColor: 'rgba(255, 255, 255, 0.1)',
  margin: '8px 0',
});

export const LargeAvatar = styled(MuiAvatar)(({ theme }) => ({
  width: 56,
  height: 56,
  fontWeight: 600,
  fontSize: '1.5rem',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
}));
